import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { NivelFullSchema, NivelValorSchema, } from '@/data/dto/nivelAdmin';
export const nivelesAdminApi = {
    async listarPorDisciplina(clave) {
        const res = await apiClient.get(`/api/gestion/v1/disciplinas/${clave}/niveles`);
        const data = res.data;
        if (Array.isArray(data))
            return z.array(NivelFullSchema).parse(data);
        return z.object({ items: z.array(NivelFullSchema) }).parse(data).items;
    },
    async crear(values) {
        const res = await apiClient.post('/api/gestion/v1/niveles', values);
        return NivelFullSchema.parse(res.data);
    },
    async editar(id, values) {
        const res = await apiClient.patch(`/api/gestion/v1/niveles/${id}`, values);
        return NivelFullSchema.parse(res.data);
    },
    async desactivar(id) {
        await apiClient.delete(`/api/gestion/v1/niveles/${id}`);
    },
    async listarValores(nivelId) {
        const res = await apiClient.get(`/api/gestion/v1/niveles/${nivelId}/valores`);
        return z.object({ items: z.array(NivelValorSchema) }).parse(res.data).items;
    },
    async crearValor(nivelId, values) {
        const res = await apiClient.post(`/api/gestion/v1/niveles/${nivelId}/valores`, values);
        return NivelValorSchema.parse(res.data);
    },
    async cerrarValor(valorId, hasta) {
        const res = await apiClient.post(`/api/gestion/v1/valores-nivel/${valorId}/cerrar`, {
            hasta,
        });
        return NivelValorSchema.parse(res.data);
    },
};
